export interface LoaderStateModel {
  status: boolean | null;
}

export class ShowLoader {
  static readonly type = '[LoadingBar] Show loader';
}

export class HideLoader {
  static readonly type = '[LoadingBar] Hide loader';
}
